<template>
  <v-row justify="center">
    <v-dialog
        v-model="datePickerDialog"
        max-width="620px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('DatePickerDialog.headline') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
              >
                <v-menu
                    v-model="dateStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="valueStart"
                        :label="start"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="valueStart"
                      :max="new Date().toISOString().substr(0, 10)"
                      scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
              >
                <v-menu
                    v-model="dateEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="valueEnd"
                        :label="end"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="valueEnd"
                      :max="new Date().toISOString().substr(0, 10)"
                      scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              class="text--secondary"
              text
              @click="closeDialog"
          >
            {{ $t('DatePickerDialog.cancel') }}
          </v-btn>
          <v-btn
              class="text--secondary"
              text
              @click="downloadExcel">
            {{ $t('DatePickerDialog.download') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from 'moment';
import eventBus from '../plugins/EventBus'

export default {
  data() {
    return {
      dateStart: false,
      dateEnd: false,
      datePickerDialog: false,
      allData: false,
      project: false,
      valueStart: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      valueEnd: moment(new Date()).format('YYYY-MM-DD'),
    }
  },
  computed: {
    start: function (){
      return this.$t('DatePickerDialog.start')
    },
    end: function () {
      return this.$t('DatePickerDialog.end')
    }
  },
  mounted: function () {
    eventBus.$on('datePickerDialog', datePickerDialog => {
      this.datePickerDialog = datePickerDialog
      this.allData = datePickerDialog
    })
    eventBus.$on('datePickerDialogProject', datePickerDialogProject => {
      this.datePickerDialog = datePickerDialogProject
      this.project = datePickerDialogProject
    })
  },
  methods: {
    downloadExcel: function () {
      let selectedInterval = [{
        start: this.valueStart,
        end: this.valueEnd
      }]
      if (this.project) {
        eventBus.$emit('downloadWithAxiosProject', selectedInterval)
      } else if (this.allData) {
        eventBus.$emit('downloadWithAxios', selectedInterval)
      }
      this.allData = false
      this.project = false
      this.datePickerDialog = false
    },
    closeDialog() {
      this.datePickerDialog = false
    }
  }
}
</script>
